import { FunctionComponent, useContext } from 'react';
import classnames from 'classnames';

import { CookieKeys } from 'types/cookies';

import { Genders } from 'models/Product';

import { imageResizer } from 'utils/image';
import { getProvider } from 'services/Cookies';

import vars from 'theme/styles/vars';

import LocaleContext from 'components/context/Locale';
import LayoutContainer from 'components/layout/LayoutContainer';
import ContactForm from 'components/modules/public/layout/forms/ContactForm';

import StyledComponent from './styles';
import { Props } from './types';

const PublicLayoutSectionContact: FunctionComponent<Props> = ({
    layoutContainerProps,
    translations,
    children,
    contactTranslations,
    sectionSettings,
    removeLocationSelect,
    isBusinessMode,
    formName,
}) => {
    const localeContext = useContext(LocaleContext);
    const cookieGender: Genders = getProvider().get(CookieKeys.Gender);

    if (!contactTranslations) {
        translations = {
            ...localeContext?.translations?.blockContact,
            ...(translations || {}),
        };
    } else {
        translations = contactTranslations;
    }

    const image = cookieGender === Genders.Male ? translations?.imageMale : translations?.imageFemale;

    return (
        <StyledComponent
            className={classnames('public-layout-section-contact',
                contactTranslations && 'public-layout-section-contact-single-form'
            )}
            overrideStyles={`
                .cols {
                    .col-form {
                        .background-image {
                            background-image: url(${imageResizer(image, { width: 1083, height: 617 })});
                        }        
                    }
                }

                @media all and (max-width: ${vars.tabletS}) {
                    .cols {
                        .col-form {
                            .background-image {
                                background-image: url(${imageResizer(image, { width: 768, height: 432 })});
                            } 
                        }
                    }
                }

                @media all and (max-width: ${vars.mobileM}) {
                    .cols {
                        .col-form {
                            .background-image {
                                background-image: url(${imageResizer(image, { width: 480, height: 270 })});
                            } 
                        }
                    }
                }
            `}
        >
            <LayoutContainer {...layoutContainerProps}>
                {!contactTranslations ? (
                    <>
                        <div className="cols">
                            <div className="col-copy">
                                <div
                                    className="headline"
                                    dangerouslySetInnerHTML={{ __html: translations?.headline }}
                                />
                                {translations?.subheadline && (
                                    <div
                                        className="subheadline"
                                        dangerouslySetInnerHTML={{ __html: translations?.subheadline }}
                                    />
                                )}
                            </div>
                            <div className="col-form">
                                <div className="form-container">
                                    {children
                                        ? children
                                        : (
                                            <ContactForm
                                                translations={{
                                                    ...translations?.contactForm,
                                                    contactFormHeader: translations?.contactFormHeader,
                                                    contactFormSubHeader: translations?.contactFormSubHeader,
                                                }}
                                                contactLead
                                                sectionSettings={sectionSettings}
                                                removeLocationSelect={removeLocationSelect}
                                                isBusinessMode={isBusinessMode}
                                                patronEmail={translations?.patronEmail}
                                                formName={formName}
                                            />
                                        )}
                                </div>

                                {image && (
                                    <span className="background-image" />
                                )}
                            </div>
                        </div>
                    </>
                ) : (
                    <div className="form-container">
                        {children
                            ? children
                            : (
                                <ContactForm
                                    translations={translations as any}
                                    sectionSettings={sectionSettings}
                                    isBusinessMode={isBusinessMode}
                                    patronEmail={translations?.patronEmail}
                                    formName={formName}
                                />
                            )}
                    </div>
                )}
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicLayoutSectionContact;
